/* src/app/account/account-allocations/posting-account/posting-account.component.scss */
body#themeTag :host ::ng-deep .p-datatable .p-datatable-tbody td.p-datatable-cell {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
}
body#themeTag :host ::ng-deep .p-datatable .p-datatable-scrollable-header {
  height: 5.75em;
}
/*# sourceMappingURL=posting-account.component.css.map */
